(function ($) {

    $(() => {

        if (!$('#js-hero').length) {
            return;
        }

        if (!$('.js-pool-img').length) {
            return;
        }



        function fade() {
            let pool = $('.js-pool-img');
            let currentImages = $('.js-current-image');

            const randomPoolIndex = Math.floor(Math.random() * pool.length)
            const randomCurrentIndex = Math.floor(Math.random() * currentImages.length);
            var item = pool[randomPoolIndex];
            var current = currentImages[randomCurrentIndex];

            $(current).fadeTo(1000, 0.10, function () {
                const itemSrc = $(item).attr("src");

                $(item).attr("src", $(current).attr("src"));
                $(current).attr("src", itemSrc);
            }).fadeTo(500, 1);

            return false;
        };



        const intervalIds = [];

        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach(entry => {
                    const entryId = $(entry.target).attr('id');

                    if (entry.isIntersecting) {
                        const intervalID = setInterval(fade, 3000);
                        intervalIds[entryId] = intervalID;
                    } else {
                        const clearId = intervalIds[entryId];
                        clearInterval(clearId);
                    }
                });
            },
            { threshold: 0.1 }
        );


        $('#js-hero').each(function (i) {
            observer.observe(this);
        });
    });
})(jQuery);


